import { render, staticRenderFns } from "./SearchKeyRankMgmt.vue?vue&type=template&id=0c1b0c0c&scoped=true"
import script from "./SearchKeyRankMgmt.vue?vue&type=script&lang=js"
export * from "./SearchKeyRankMgmt.vue?vue&type=script&lang=js"
import style0 from "./SearchKeyRankMgmt.vue?vue&type=style&index=0&id=0c1b0c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b0c0c",
  null
  
)

export default component.exports